// Message code define


// Endpoint
export const ColumnEndPoint = {
  CREATE: 'admin/column-av/create',
  UPDATE: 'admin/column-av/update',
  DELETE: 'admin/column-av/delete',
  GET_BY_ACTIVITY_ID: 'admin/column-av/by-activity-id',
}